import styled from 'styled-components';

export const Container = styled.div`
  .ant-fullcalendar-header {
    margin-bottom: 20px;
  }
`;
